const props = {
	seriesArticleNavData: {
		parentDoi: "d41586-020-01523-1",
		headline: "<h2>Science after the pandemic</h2>",
		stand: "<p>A <i>Nature</i> series charts how research will change.</p>",
		articles: [
			{
				title: "Universities will never be the same after the coronavirus crisis",
				url: "https://www.nature.com/articles/d41586-020-01518-y",
				doi: "d41586-020-01518-y",
				published: true,
			},
			{
				title: "Sputnik moment or budget breaker: How will the pandemic alter research funding?",
				url: "https://www.nature.com/articles/d41586-020-01519-x",
				doi: "d41586-020-01519-x",
				published: true,
			},
			{
				title: "How scientific conferences will survive the coronavirus shock",
				url: "https://www.nature.com/articles/d41586-020-01521-3",
				doi: "d41586-020-01521-3",
				published: true,
			},
			{
				title: "Will the pandemic permanently alter scientific publishing?",
				url: "https://www.nature.com/articles/d41586-020-01520-4",
				doi: "d41586-020-01520-4",
				published: true,
			},
			{
				title: "The pandemic is challenging China’s breakneck race to the top of science",
				url: "https://www.nature.com/articles/d41586-020-01522-2",
				doi: "d41586-020-01522-2",
				published: true,
			},
			{
				title: "Scientists’ worlds will shrink in the wake of the pandemic",
				url: "https://www.nature.com/articles/d41586-020-01523-1",
				doi: "d41586-020-01523-1",
				published: true,
			},
			{
				title: "The coronavirus outbreak could make it quicker and easier to trial drugs",
				url: "https://www.nature.com/articles/d41586-020-01524-0",
				doi: "d41586-020-01524-0",
				published: true,
			},
			{
				title: "The pandemic mixed up what scientists study – and some won’t go back",
				url: "https://www.nature.com/articles/d41586-020-01525-z",
				doi: "d41586-020-01525-z",
				published: true,
			}
		]
	},
}

module.exports = props;
